export const appName = "lk.yogansk";
export const backedUrl = "https://api.lk.yoga-nsk.ru";